export default function Toast({ toast, onRemove }) {
  const getIcon = (type) => {
    switch (type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'info': return 'ℹ';
      case 'warning': return '⚠';
      default: return '📢';
    }
  };

  const getBackgroundColor = (type) => {
    switch (type) {
      case 'success': return 'bg-green-500';
      case 'error': return 'bg-red-500';
      case 'info': return 'bg-blue-500';
      case 'warning': return 'bg-yellow-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div
      className={`${getBackgroundColor(toast.type)} text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in`}
      role="alert"
      style={{ minWidth: '300px', maxWidth: '400px' }}
    >
      <span className="flex-shrink-0 text-lg font-bold">{getIcon(toast.type)}</span>
      <span className="flex-1 text-sm">{toast.message}</span>

      {toast.action && (
        <button
          onClick={() => toast.action.handler()}
          className="text-white underline hover:no-underline text-sm font-medium"
        >
          {toast.action.label}
        </button>
      )}

      <button
        onClick={() => onRemove(toast.id)}
        className="text-white hover:text-gray-200 text-lg leading-none"
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
}
